export default __webpack_public_path__ + "static/media/transaction.a0e51293.svg";